<template>
  <div id="acctLogin" class="jcs-portal-card">
    <div class="container">
      <h1>Account Login</h1>
      <div class="row">
        <div class="col-lg-6 mb-4 mb-lg-0">
          <form
            id="resetForm"
            @submit.prevent="resetpassword"
            v-bind:class="{ error: error }"
          >
            <div class="ui error message" v-if="error">{{ error }}</div>
            <div class="form-row">
              <label for="inputEmail">Email Address</label>
              <input
                v-model="email"
                type="email"
                id="inputEmail"
                placeholder="Email address"
                required
                autofocus
              />
            </div>
            <div class="form-row align-items-center">
              <button
                class="ui btn-primary col-sm-6 mb-4 mb-sm-0"
                type="submit"
              >
                reset my password
              </button>
              <router-link
                to="/login"
                tag="a"
                class="forgot-pw col-sm-5 offset-sm-1 text-sm-right"
                >return to login</router-link
              >
            </div>
          </form>
        </div>
        <div class="col-lg-6 align-items-center">
          <div id="createAcct">
            <h2>Create A New Account</h2>
            <p>
              J.C. Steele is proud to introduce the new Steele Service, a database-driven web component designed to be the foundation of future e-commerce phases. The new Steele Service website is an online order entry system for J.C. Steele's existing customers. 
            </p>
            <router-link
              to="/Registration"
              tag="a"
              class="col-sm-6 btn btn-primary"
              >Request new account</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "expose-loader?$!expose-loader?jQuery!jquery";

import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "ResetPassword",
  data() {
    return {
      email: "",
      error: false,
      loader: this.loader,
    };
  },
  computed: {},
  created() {
    this.checkCurrentLogin();
  },
  updated() {
    this.checkCurrentLogin();
  },
  methods: {
    // Defense-in-depth (CodeQL open-redirect, 2026-08-01): only honor a ?redirect= that is a same-origin
    // RELATIVE path ("/..." but not "//..."). $router.replace resolves same-origin already, so this isn't
    // exploitable today, but the guard means a future swap to window.location can't regress into an open
    // redirect. Mirrors Login.vue's guard.
    safeRedirect(fallback) {
      var r = this.$route.query.redirect;
      return (r && String(r).charAt(0) === "/" && String(r).charAt(1) !== "/") ? String(r) : fallback;
    },
    checkCurrentLogin() {
      if (this.currentUser) {
        this.$router.replace(this.safeRedirect("/admin/index"));
      }
    },
    resetpassword() {
      this.loader = true;
      apiService
        .reset(this.email)
        .then((request) => {
          this.resetSuccessful(request);
        })
        .catch((err) => this.resetFailed(err));
    },
    resetSuccessful() {
      this.loader = false;
      this.error = false;
      this.$store.dispatch("login");
      this.$router.replace(this.safeRedirect("/login"));
    },
    resetFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
      this.loader = false;
      this.$store.dispatch("logout");
      delete localStorage.token;
      this.$router.replace(this.safeRedirect("/login"));
    },
  },
};
</script>
